// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   loading: false,
//   error: null,
//   applicants: {
//     data: [],
//     total: 0,
//   },
//   notes: {
//     data: [],
//     total: 0,
//   },
// };

// const sourcingSlice = createSlice({
//   name: "sourcing",
//   initialState,
//   reducers: {
//     // -------- ALL APPLICANTS --------
//     fetchAllApplicantsStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     fetchAllApplicantsSuccess(state, action) {
//       state.loading = false;
//       state.applicants.data = action.payload.data || [];
//       state.applicants.total =
//         action.payload.total || action.payload.data?.length || 0;
//     },
//     updateSingleApplicant(state, action) {
//       try {
//         const index = state.applicants.data.findIndex(
//           a => a.uiid === action.payload.uiid
//         );

//         if (index !== -1) {
//           state.applicants.data[index] = action.payload;
//         } else {
//           state.applicants.data.push(action.payload);
//         }
//       }
//       catch (err) {
//         console.error("Error in updateSingleApplicant reducer:", err);
//       }
//     },
//     fetchAllApplicantsFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     clearApplicants(state) {
//       state.applicants = { data: [], total: 0 };
//       state.loading = false;
//       state.error = null;
//     },
//     // updateApplicantNotes: (state, action) => {
//     //   const { applicantId, newNoteUiid } = action.payload;

//     //   state.applicants.data = state.applicants.data.map((a) =>
//     //     a.uiid === applicantId
//     //       ? { ...a, notes: [...(a.notes || []), newNoteUiid] }
//     //       : a
//     //   );
//     // },
//     getNotesStart(state) {
//       state.loading = true;
//       state.error = null;
//     },
//     getNotesSuccess(state, action) {
//       state.loading = false;
//       state.notes.data = action.payload.data || [];
//       state.notes.total = action.payload.total || 0;
//     },
//     getNotesFailure(state, action) {
//       state.loading = false;
//       state.error = action.payload;
//     },
//     updateApplicantNotes: (state, action) => {
//       const { applicantId, newNoteUiid, note, addedBy, addedOn, uiid } =
//         action.payload || {};

//       const applicant = state.applicants.data.find(
//         (a) => String(a.uiid) === String(applicantId),
//       );
//       if (!applicant) return;
//       applicant.notes ??= [];
//       applicant.notesList ??= [];
//       const exists = applicant.notesList.some(
//         (n) => String(n.uiid) === String(uiid),
//       );
//       if (!exists) {
//         applicant.notesList.unshift({
//           uiid,
//           note,
//           addedBy,
//           addedOn,
//         });
//         applicant.notesList.sort(
//           (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
//         );
//       }
//       const noteExists = applicant.notes.some(
//         (id) => String(id) === String(newNoteUiid),
//       );

//       if (!noteExists) {
//         applicant.notes.push(newNoteUiid);
//       }
//     },
//     updateApplicantWithNotes: (state, action) => {
//       const { applicantId, note, addedBy, addedOn, uiid } =
//         action.payload || {};
//       const applicant = state.applicants.data.find(
//         (a) => String(a.uiid) === String(applicantId),
//       );
//       if (!applicant) return;
//       applicant.notes ??= [];
//       applicant.notesList ??= [];
//       const noteExists = applicant.notes.some(
//         (id) => String(id) === String(uiid),
//       );
//       if (!noteExists) {
//         applicant.notes.push(uiid);
//       }
//       const alreadyExists = applicant.notesList.some(
//         (n) => String(n.uiid) === String(uiid),
//       );
//       if (!alreadyExists) {
//         applicant.notesList.push({
//           uiid,
//           note,
//           addedBy,
//           addedOn,
//         });
//         applicant.notesList.sort(
//           (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
//         );
//       }
//     },
//     updateApplicantsNotesArray: (state, action) => {
//       const { applicantId, notes } = action.payload || {};
//       const safeNotes = Array.isArray(notes) ? notes : [];
//       const noteIds = safeNotes
//         .map((n) => (typeof n === "object" ? n?.uiid : n))
//         .filter(Boolean);
//       state.applicants.data = state.applicants.data.map((a) => {
//         if (String(a.uiid) !== String(applicantId)) return a;
//                 const existingNotesList = Array.isArray(a.notesList) ? a.notesList : [];
//         const mergedNotesList = Array.from(new Map([...existingNotesList, ...safeNotes].map(n => [String(n.uiid), n])).values())
//           .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));
//         return {
//           ...a,
//           notesList: mergedNotesList,
//           notes: [
//             ...new Set([
//               ...(Array.isArray(a.notes) ? a.notes : []),
//               ...noteIds,
//             ]),
//           ],
//         };
//       });
//     },
//      updateSingleApplicant(state, action) {
//       try {
//         const index = state.applicants.data.findIndex(
//           a => a.uiid === action.payload.uiid
//         );

//         if (index !== -1) {
//           state.applicants.data[index] = action.payload;
//         } else {
//           state.applicants.data.push(action.payload);
//         }
//       }
//       catch (err) {
//         console.error("Error in updateSingleApplicant reducer:", err);
//       }
//     },
//   },
// });

// export const {
//   fetchAllApplicantsStart,
//   fetchAllApplicantsSuccess,
//   fetchAllApplicantsFailure,
//   clearApplicants,
//   updateApplicantNotes,
//   updateApplicantWithNotes,
//   getNotesStart,
//   getNotesSuccess,
//   getNotesFailure,
//   updateApplicantsNotesArray,
//   updateSingleApplicant,
// } = sourcingSlice.actions;

// export default sourcingSlice.reducer;



import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  applicants: {
    data: [],
    total: 0,
  },
  notes: {
    data: [],
    total: 0,
  },
};

const sourcingSlice = createSlice({
  name: "sourcing",
  initialState,
  reducers: {
    // -------- ALL APPLICANTS --------
    fetchAllApplicantsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchAllApplicantsSuccess(state, action) {
      state.loading = false;
      state.applicants.data = action.payload.data || [];
      state.applicants.total =
        action.payload.total || action.payload.data?.length || 0;
    },
    updateSingleApplicant(state, action) {
      try {
        const index = state.applicants.data.findIndex(
          a => a.uiid === action.payload.uiid
        );

        if (index !== -1) {
          state.applicants.data[index] = action.payload;
        } else {
          state.applicants.data.push(action.payload);
        }
      }
      catch (err) {
        console.error("Error in updateSingleApplicant reducer:", err);
      }
    },
    fetchAllApplicantsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearApplicants(state) {
      state.applicants = { data: [], total: 0 };
      state.loading = false;
      state.error = null;
    },
    // updateApplicantNotes: (state, action) => {
    //   const { applicantId, newNoteUiid } = action.payload;

    //   state.applicants.data = state.applicants.data.map((a) =>
    //     a.uiid === applicantId
    //       ? { ...a, notes: [...(a.notes || []), newNoteUiid] }
    //       : a
    //   );
    // },
    getNotesStart(state) {
      state.loading = true;
      state.error = null;
    },
    getNotesSuccess(state, action) {
      state.loading = false;
      state.notes.data = action.payload.data || [];
      state.notes.total = action.payload.total || 0;
    },
    getNotesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    updateApplicantNotes: (state, action) => {
      const { applicantId, newNoteUiid, note, addedBy, addedOn, uiid } =
        action.payload || {};

      const applicant = state.applicants.data.find(
        (a) => String(a.uiid) === String(applicantId),
      );
      if (!applicant) return;
      applicant.notes ??= [];
      applicant.notesList ??= [];
      const exists = applicant.notesList.some(
        (n) => String(n.uiid) === String(uiid),
      );
      if (!exists) {
        applicant.notesList.unshift({
          uiid,
          note,
          addedBy,
          addedOn,
        });
        applicant.notesList.sort(
          (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
        );
      }
      const noteExists = applicant.notes.some(
        (id) => String(id) === String(newNoteUiid),
      );

      if (!noteExists) {
        applicant.notes.push(newNoteUiid);
      }
    },
    updateApplicantVisitHistory: (state, action) => {
      const { applicantId, visitHistory, addedBy, addedOn, uiid } =
        action.payload || {};

      const applicant = state.applicants.data.find(
        (a) => String(a.uiid) === String(applicantId),
      );
      if (!applicant) return;
      applicant.visitHistory ??= [];
      applicant.visitHistoryList ??= [];
      const exists = applicant.visitHistoryList.some(
        (v) => String(v.uiid) === String(uiid),
      );
      if (!exists) {
        applicant.visitHistoryList.unshift({
          uiid,
          addedBy,
          addedOn,
        });
        applicant.visitHistoryList.sort(
          (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
        );
        // Limit to 5 items
        if (applicant.visitHistoryList.length > 5) {
          applicant.visitHistoryList = applicant.visitHistoryList.slice(0, 5);
        }
      }
      const visitExists = applicant.visitHistory.some(
        (id) => String(id) === String(uiid),
      );

      if (!visitExists) {
        applicant.visitHistory.push(uiid);
      }
    },
    updateApplicantWithNotes: (state, action) => {
      const { applicantId, note, addedBy, addedOn, uiid } =
        action.payload || {};
      const applicant = state.applicants.data.find(
        (a) => String(a.uiid) === String(applicantId),
      );
      if (!applicant) return;
      applicant.notes ??= [];
      applicant.notesList ??= [];
      const noteExists = applicant.notes.some(
        (id) => String(id) === String(uiid),
      );
      if (!noteExists) {
        applicant.notes.push(uiid);
      }
      const alreadyExists = applicant.notesList.some(
        (n) => String(n.uiid) === String(uiid),
      );
      if (!alreadyExists) {
        applicant.notesList.push({
          uiid,
          note,
          addedBy,
          addedOn,
        });
        applicant.notesList.sort(
          (a, b) => new Date(b.addedOn) - new Date(a.addedOn),
        );
      }
    },
    updateApplicantsNotesArray: (state, action) => {
      const { applicantId, notes } = action.payload || {};
      const safeNotes = Array.isArray(notes) ? notes : [];
      const noteIds = safeNotes
        .map((n) => (typeof n === "object" ? n?.uiid : n))
        .filter(Boolean);
      state.applicants.data = state.applicants.data.map((a) => {
        if (String(a.uiid) !== String(applicantId)) return a;
        const replacedNotesList = Array.from(
          new Map(safeNotes.map((n) => [String(n.uiid || n._id), n])).values(),
        ).sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));
        return {
          ...a,
          notesList: replacedNotesList,
          notes: [...new Set(noteIds)],
        };
      });
    },
    updateApplicantsVisitHistoryArray: (state, action) => {
      const { applicantId, visitHistory } = action.payload || {};
      const safeVisits = Array.isArray(visitHistory) ? visitHistory : [];
      const visitIds = safeVisits
        .map((v) => (typeof v === "object" ? v?.uiid : v))
        .filter(Boolean);
      state.applicants.data = state.applicants.data.map((a) => {
        if (String(a.uiid) !== String(applicantId)) return a;
        const existingVisitHistoryList = Array.isArray(a.visitHistoryList) ? a.visitHistoryList : [];
        const mergedVisitHistoryList = Array.from(new Map([...existingVisitHistoryList, ...safeVisits].map(v => [String(v.uiid), v])).values())
          .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn))
          .slice(0, 5);
        return {
          ...a,
          visitHistoryList: mergedVisitHistoryList,
          visitHistory: [
            ...new Set([
              ...(Array.isArray(a.visitHistory) ? a.visitHistory : []),
              ...visitIds,
            ]),
          ],
        };
      });
    },
  },
});

export const {
  fetchAllApplicantsStart,
  fetchAllApplicantsSuccess,
  fetchAllApplicantsFailure,
  clearApplicants,
  updateApplicantNotes,
  updateApplicantWithNotes,
  getNotesStart,
  getNotesSuccess,
  getNotesFailure,
  updateApplicantsNotesArray,
  updateApplicantsVisitHistoryArray,
  updateSingleApplicant,
  updateApplicantVisitHistory,
} = sourcingSlice.actions;

export default sourcingSlice.reducer;
